import { fromJS, Map } from 'immutable';
import {
  closeSidebar,
  removeAddressById,
  requestAddresses,
  requestSapAddresses,
  createAddress,
  setEditAddress,
  setMergedAddresses,
  toggleSidebar,
  clearMergedAddresses
} from './actions';
import { unionBy } from '../util/lodash';

export const defaultState = Map({
  addresses: [],
  sapAddresses: [],
  mergedAddresses: [],
  validationError: '',
  sidebarOpen: false,
  editAddress: null
});

export default function addressBook(state = defaultState, action) {
  const newState = fromJS(state); // Force immutable in case of rehydration

  switch (action.type) {
    case requestAddresses.event.success:
      return newState.set('addresses', action.payload);
    case requestSapAddresses.event.success:
      return newState.set('sapAddresses', action.payload);
    case clearMergedAddresses.type:
      return newState.set('mergedAddresses', []);
    case setMergedAddresses.type: {
      const currentMergedAddresses = newState.get('mergedAddresses');
      const addOrReplaceAddresses = (newAds, oldAds) => unionBy('id', newAds, oldAds);
      const newAddresses = Array.isArray(action.payload) ? action.payload : [action.payload];
      const updatedList = addOrReplaceAddresses(newAddresses, currentMergedAddresses);

      return newState.set('mergedAddresses', updatedList);
    }
    case removeAddressById.type:
      return newState.set(
        'mergedAddresses',
        state.get('mergedAddresses').filter(address => address.id !== action.payload)
      );
    case createAddress.event.success:
      return newState;
    case toggleSidebar.type:
      return newState.set('sidebarOpen', !newState.get('sidebarOpen'));
    case closeSidebar.type:
      return newState.set('sidebarOpen', false);
    case setEditAddress.type:
      return newState.set(
        'editAddress',
        newState.get('sidebarOpen') === false ? action.payload : defaultState.get('editAddress')
      );
    default:
      return newState;
  }
}
